const RESET_PASSWORD_TOKEN = /(\/(?:api\/users\/)?reset-password\/)[A-Za-z0-9._-]+/g;
const TOKEN_QUERY_PARAMETER = /([?&]token=)[^&#\s"']+/gi;
const JWT = /\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g;
const REDACTED = "[REDACTED]";

export const redactSentryAuthTokens = (value: string): string =>
    value
        .replace(RESET_PASSWORD_TOKEN, `$1${REDACTED}`)
        .replace(TOKEN_QUERY_PARAMETER, `$1${REDACTED}`)
        .replace(JWT, REDACTED);

const redactValue = (value: unknown, seen: WeakMap<object, unknown>): unknown => {
    if (typeof value === "string") {
        return redactSentryAuthTokens(value);
    }

    if (Array.isArray(value)) {
        const existing = seen.get(value);
        if (existing) return existing;

        const redacted: unknown[] = [];
        seen.set(value, redacted);
        value.forEach((entry) => redacted.push(redactValue(entry, seen)));
        return redacted;
    }

    if (value !== null && typeof value === "object") {
        const prototype = Object.getPrototypeOf(value);
        if (prototype !== Object.prototype && prototype !== null) {
            return value;
        }

        const existing = seen.get(value);
        if (existing) return existing;

        const redacted = Object.create(prototype) as Record<string, unknown>;
        seen.set(value, redacted);
        Object.entries(value).forEach(([key, entry]) => {
            Object.defineProperty(redacted, key, {
                value: redactValue(entry, seen),
                enumerable: true,
                configurable: true,
                writable: true,
            });
        });
        return redacted;
    }

    return value;
};

export const redactSentryPayload = <T>(value: T): T => redactValue(value, new WeakMap()) as T;
